const ADD_SELECTOR = 'button[name="add"]';
const BLOCKING_OVERLAY_SELECTOR = [
  'header-drawer details[open]',
  'dialog[open]',
  '[aria-modal="true"][open]',
  'cart-drawer[open]',
  '.cart-drawer[open]',
].join(',');

class MobileStickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.addButton = this.querySelector('[data-sticky-add]');
    this.buyButton = this.querySelector('[data-sticky-buy]');
    this.addButton?.addEventListener('click', this.handleAdd);
    this.buyButton?.addEventListener('click', this.handleBuy);
    this.bindSourceForm();
    this.overlayObserver = new MutationObserver(this.syncOverlayState);
    this.overlayObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden', 'class'],
      childList: true,
      subtree: true,
    });
    this.syncOverlayState();
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.handleAdd);
    this.buyButton?.removeEventListener('click', this.handleBuy);
    this.formObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    this.overlayObserver?.disconnect();
  }

  bindSourceForm() {
    const formId = this.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    if (!(form instanceof HTMLFormElement)) return;

    this.sourceForm = form;
    this.formObserver = new MutationObserver(this.syncState);
    this.formObserver.observe(form, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting);
      },
      { threshold: 0.12 }
    );
    this.visibilityObserver.observe(form);
    this.syncState();
  }

  get sourceAddButton() {
    return this.sourceForm?.querySelector(ADD_SELECTOR);
  }

  syncState = () => {
    const sourceAdd = this.sourceAddButton;
    const addLabel = sourceAdd?.querySelector('.add-to-cart-text__content')?.textContent?.trim();
    const unavailable = !sourceAdd || sourceAdd.disabled;

    if (this.addButton) {
      this.addButton.disabled = unavailable;
      if (addLabel) this.addButton.textContent = addLabel;
    }
    if (this.buyButton) {
      this.buyButton.disabled = unavailable;
    }
  };

  syncOverlayState = () => {
    this.hidden = Boolean(document.querySelector(BLOCKING_OVERLAY_SELECTOR));
  };

  track(action) {
    const variantId = this.sourceForm?.querySelector('input[name="id"]')?.value;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'mobile_sticky_cta_click', {
        cta_type: action,
        product_id: this.dataset.productId,
        variant_id: variantId,
      });
    }
  }

  handleAdd = () => {
    const sourceAdd = this.sourceAddButton;
    if (!sourceAdd || sourceAdd.disabled) return;
    this.track('add_to_cart');
    sourceAdd.click();
  };

  handleBuy = async () => {
    if (!this.sourceForm || !this.buyButton || this.buyButton.disabled) return;
    this.track('buy_now');
    this.buyButton.disabled = true;
    this.buyButton.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(this.sourceForm.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.sourceForm),
      });
      if (!response.ok) throw new Error('Unable to add the selected variant');
      window.location.assign('/checkout');
    } catch (error) {
      this.buyButton.removeAttribute('aria-busy');
      this.syncState();
      console.error(error);
    }
  };
}

if (!customElements.get('mobile-sticky-buy-bar')) {
  customElements.define('mobile-sticky-buy-bar', MobileStickyBuyBar);
}
